import React from 'react';

/**
 * Renders `fallback` instead of crashing the tree when a descendant throws.
 *
 * Needed wherever config-authored code runs during render — `new Function`
 * bodies from event options are compiled per row, so one malformed entry would
 * otherwise take down everything mounted alongside it.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error, info) {
        console.warn('omnigo: render failed', error, info);
    }

    render() {
        return this.state.failed ? (this.props.fallback ?? null) : this.props.children;
    }
}

export default ErrorBoundary;
